export const headerTemplate = (settings) => {
  return `
  <!--[if mso]>
    <xml>
        <w:WordDocument xmlns:w="urn:schemas-microsoft-com:office:word">
            <w:DontUseAdvancedTypographyReadingMail/>
        </w:WordDocument>
        <o:OfficeDocumentSettings>
            <o:PixelsPerInch>96</o:PixelsPerInch>
            <o:AllowPNG/>
        </o:OfficeDocumentSettings>
    </xml>
    <![endif]-->
    <style>
      * {
        box-sizing: border-box
      }

      body {
        margin: 0;
        padding: 0
      }

      a[x-apple-data-detectors] {
        color: inherit !important;
        text-decoration: inherit !important
      }

      #MessageViewBody a {
        color: inherit;
        text-decoration: none
      }

      p {
        line-height: inherit
      }

      .desktop_hide, .desktop_hide table {
        mso-hide: all;
        display: none;
        max-height: 0;
        overflow: hidden
      }

      .image_block img + div {
        display: none
      }

      sub, sup {
        font-size: 75%;
        line-height: 0
      }

      @media (max-width: 520px) {
        .mobile_hide {
          display: none
        }

        .row-content {
          width: 100% !important
        }

        .stack .column {
          width: 100%;
          display: block
        }

        .mobile_hide {
          min-height: 0;
          max-height: 0;
          max-width: 0;
          overflow: hidden;
          font-size: 0
        }

        .desktop_hide, .desktop_hide table {
          display: table !important;
          max-height: none !important
        }
      }
    </style>
    <!--[if mso ]>
    <style>sup, sub {
        font-size: 100% !important;
    }

    sup {
        mso-text-raise: 10%
    }

    sub {
        mso-text-raise: -10%
    }</style> <![endif]-->`;
};
export const itemTemplate = (settings) => {
  const location = settings.showLocation
    ? `• *|FEEDITEM:CATEGORIES|*<strong>`
    : "";

  const addToCalendar = settings.showAddToCalMore
    ? `<strong>
      <a
        href="*|FEEDITEM:URL|*?_s=email#add-to-calendar"
        style="text-decoration-color: ${settings.addToCalColor};"
      >
        <span style="word-break: break-word; color: ${settings.addToCalColor};text-decoration-color: ${settings.addToCalColor};">
          Add to Calendar
        </span>
      </a>
    </strong>`
    : "";

  return `  
<table class="row row-1" align="left"
                   width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation"
                   style="mso-table-lspace:0;mso-table-rspace:0; width: 100%;background-color:${settings.bgColor}" >
                <tbody>
                <tr>
                    <td>
                        <table class="row-content stack" align="left" border="0" cellpadding="0" cellspacing="0"
                               role="presentation"
                               style="mso-table-lspace:0;mso-table-rspace:0;border-radius:0;color:#000;margin:0 auto">
                            <tbody>
                            <tr>
                                <td class="column column-1" width="100%"
                                    style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:0;padding-left:20px;padding-right:20px;padding-top:12px;vertical-align:top;border-radius:0">
                                    <table class="paragraph_block block-2" width="100%" border="0" cellpadding="0"
                                           cellspacing="0" role="presentation"
                                           style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word">
                                        <tr>
                                            <td class="pad" style="padding-top:2px">
                                                <div style="color:${settings.dateLocationColor};direction:ltr;font-family:Arial,Helvetica Neue,Helvetica,sans-serif;font-size:14px;font-weight:400;letter-spacing:0;line-height:1.2;text-align:left;mso-line-height-alt:17px">
                                                    <p style="margin:0">
                                                        *|FEEDITEM:DATE:M d|* - <span
                                                            style="word-break: break-word; color: ${settings.titleColor};"><a href="*|FEEDITEM:URL|*?_s=email" style="color: ${settings.titleColor};text-decoration: none"><strong>*|FEEDITEM:TITLE|*</strong></a> <span
                                                            style="word-break: break-word; color: ${settings.dateLocationColor};">• </span></span>@*|FEEDITEM:DATE:h:iA|*
                                                        ${location} ${addToCalendar} 
                                                        
                                                    </p>
                                                  </div>
                                            </td>
                                        </tr>
                                    </table>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>`;
};
